import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ApiService } from './../../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PresenceService } from './../../services/presence.service';
import { CallService } from './../../services/call.service';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent  implements OnInit {
  showModal = false;
  contactForm: FormGroup;
  contactList:any=[]
  formController:any='save'
  updateContactId:any
  isLoading:boolean=false
  myContacts:any=[]
  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private router: Router,
    public presence: PresenceService,
    private callService: CallService
  ) {
     this.fetchContacts();
  }

all: any[] = [];
selected: any = null;
tab = 'all';
tabs = [
  { key: 'all', label: 'All Contacts' },
  { key: 'member', label: 'Members' },
  { key: 'custom', label: 'My Contacts' },
  { key: 'fav', label: 'Favorites' }
];
searchText = '';
sortBy = 'newest';
menuKey: string | null = null;

private get sk() { return localStorage.getItem('user_id'); }
favs: string[] = JSON.parse(localStorage.getItem('fav_contacts_' + this.sk) || '[]');
notes: any = JSON.parse(localStorage.getItem('contact_notes_' + this.sk) || '{}');

@HostListener('document:click')
closeMenu() { this.menuKey = null; }

fetchContacts() {
  this.isLoading = true;
  forkJoin({
    custom: this.apiService.getCustomContact(this.user_id).pipe(catchError((e) => { console.error('custom err', e); return of(null); })),
    mine: this.apiService.getContact(this.user_id).pipe(catchError((e) => { console.error('mine err', e); return of(null); }))
  }).subscribe(({ custom, mine }: any) => {
    console.log('custom response:', custom);
    console.log('mine response:', mine);
    this.contactList = custom?.customContacts || [];
    this.myContacts = mine?.contacts || [];
    try {
      this.buildAll();
    } catch (e) {
      console.error('buildAll error:', e);
    }
    console.log('all:', this.all);
    this.isLoading = false;
  });
}

private firstVal(v: any, key: string): string {
  if (typeof v === 'string') { try { v = JSON.parse(v); } catch { return v; } }
  if (Array.isArray(v)) v = v[0];
  if (v && typeof v === 'object') v = v[key];
  return v ? String(v) : '';
}

private photoOf(u: any): string | null {
  const p = u?.profile_image;
  if (!p || typeof p !== 'string') return null;
  return p.startsWith('data:image') || p.startsWith('http') ? p : 'data:image/jpeg;base64,' + p;
}

buildAll() {
  const members = this.myContacts.map((c: any) => ({
    key: 'm' + c.id, type: 'member', raw: c, id: c.id, userId: c.user?.id, status: c.status,
    name: ((c.user?.firstname || '') + ' ' + (c.user?.lastname || '')).trim(),
    sub: [c.user?.job_title, c.user?.company].filter(Boolean).join(' | '),
    location: [c.user?.city, c.user?.state].filter(Boolean).join(', '),
    photo: this.photoOf(c.user),
    email: c.user?.email || '', phone: c.user?.phone || '', website: c.user?.website || '',
    facebook: c.user?.facebook_url || '', twitter: c.user?.twitter_url || '', linkedin: c.user?.linkedin_url || '',
    tags: []
  }));
  const customs = this.contactList.map((c: any) => ({
    key: 'c' + c.id, type: 'custom', raw: c, id: c.id,
    name: ((c.firstname || '') + ' ' + (c.lastname || '')).trim(),
    sub: [c.position, c.company].filter(Boolean).join(' | '),
    location: this.firstVal(c.address, 'address'),
    photo: null,
    email: this.firstVal(c.email, 'email'), phone: this.firstVal(c.phone, 'phone'),
    website: this.firstVal(c.website, 'website'),
    facebook: c.facebook || '', twitter: c.twitter || '', linkedin: c.linkedin || '',
    tags: (c.tags || '').split(',').map((t: string) => t.trim()).filter(Boolean)
  }));
  this.all = [...members, ...customs];
  this.selected = this.all.find(x => x.key === this.selected?.key) || this.all[0] || null;
}

matchTab(c: any, key: string) {
  return key === 'all' || (key === 'fav' ? this.isFav(c) : c.type === key);
}
count(key: string) { return this.all.filter(c => this.matchTab(c, key)).length; }

get filtered(): any[] {
  const q = this.searchText.trim().toLowerCase();
  const list = this.all.filter(c =>
    this.matchTab(c, this.tab) &&
    (!q || (c.name + ' ' + c.sub + ' ' + c.location + ' ' + c.tags.join(' ')).toLowerCase().includes(q)));
  return list.sort(this.sortBy === 'name'
    ? (a, b) => a.name.localeCompare(b.name)
    : (a, b) => b.id - a.id);
}

select(c: any) { this.selected = c; }
toggleMenu(key: string, e: Event) { e.stopPropagation(); this.menuKey = this.menuKey === key ? null : key; }

badgeText(c: any) { return c.type === 'custom' ? 'Contact' : (c.status === 'Pending' ? 'Pending' : 'Member'); }
badgeClass(c: any) { return c.type === 'custom' ? 'b-custom' : (c.status === 'Pending' ? 'b-pending' : 'b-member'); }

/* favorites + notes (browser mein save hote hain) */
isFav(c: any) { return this.favs.includes(c.key); }
toggleFav(c: any, e?: Event) {
  e?.stopPropagation();
  this.favs = this.isFav(c) ? this.favs.filter(k => k !== c.key) : [...this.favs, c.key];
  localStorage.setItem('fav_contacts_' + this.sk, JSON.stringify(this.favs));
  this.menuKey = null;
}
setNote(key: string, val: string) {
  this.notes[key] = val;
  localStorage.setItem('contact_notes_' + this.sk, JSON.stringify(this.notes));
}

/* actions */
message(c: any, e?: Event) { e?.stopPropagation(); this.router.navigate(['/messages']); }
canCall(c: any) { return (c.type === 'member' && c.status === 'Accepted') || (c.type === 'custom' && !!c.phone); }
call(c: any, e?: Event) {
  e?.stopPropagation();
  if (c.type === 'member') this.callService.invite([c.userId]).catch(() => alert('Could not start the call'));
  else window.location.href = 'tel:' + c.phone;
}
mail(c: any, e?: Event) { e?.stopPropagation(); window.location.href = 'mailto:' + c.email; }
share(c: any) {
  const text = [c.name, c.sub, c.phone, c.email].filter(Boolean).join('\n');
  if ((navigator as any).share) (navigator as any).share({ title: c.name, text }).catch(() => {});
  else navigator.clipboard?.writeText(text).then(() => alert('Contact copied'));
}
socials(c: any) {
  const mk = (v: string, base: string) => v ? (v.startsWith('http') ? v : base + v.replace(/^@/, '')) : '';
  return [
    { icon: 'fa-brands fa-facebook-f', url: mk(c.facebook, 'https://facebook.com/') },
    { icon: 'fa-brands fa-x-twitter', url: mk(c.twitter, 'https://x.com/') },
    { icon: 'fa-brands fa-linkedin-in', url: mk(c.linkedin, 'https://linkedin.com/in/') },
    { icon: 'fa-solid fa-globe', url: c.website ? (c.website.startsWith('http') ? c.website : 'https://' + c.website) : '' }
  ].filter(s => s.url);
}

deleteContact(contact: any) {
  if (!confirm('Are You sure you want to delete this contact?')) return;
  this.isLoading = true;
  this.apiService.deleteCustomContact(this.id, contact.id).subscribe(
    (r) => {
      if (r.status == 'Success') this.fetchContacts();
      else { this.isLoading = false; alert('contact delete unsuccessful'); }
    },
    () => { this.isLoading = false; alert('contact delete failed'); }
  );
}

saveContact() {
  const c = this.contactForm.value;
  const payload: any = {
    user_id: c.user_id, firstname: c.firstName, lastname: c.lastName, tags: c.tags,
    gender: c.gender, company: c.company, position: c.position,
    facebook: c.facebook, twitter: c.twitter, linkedin: c.linkedin,
    email: JSON.stringify(c.emails.map((email: any) => ({ email }))),
    phone: JSON.stringify(c.phoneNumbers.map((phone: any) => ({ phone }))),
    address: JSON.stringify(c.addresses.map((address: any) => ({ address }))),
    website: JSON.stringify(c.websites.map((website: any) => ({ website })))
  };
  const updating = this.formController == 'update';
  if (updating) payload.id = this.updateContactId;

  this.isLoading = true;
  const req = updating ? this.apiService.updateContact(payload) : this.apiService.saveContact(payload);
  req.subscribe(
    () => { this.formController = 'save'; this.closeAddContactModal(); this.fetchContacts(); },
    () => { this.isLoading = false; alert('Could not save contact'); }
  );
}
  
   id = localStorage.getItem('user_id')
  
 user_id  = parseInt(this.id, 10); 

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      user_id:[this.user_id],
      firstName: [''],
      lastName: [''],
      tags: [''],
      gender: [''],
      company: [''],
      position: [''],
      facebook: [''],
      twitter: [''],
      linkedin: [''],
      
      emails: this.fb.array([]),
      phoneNumbers: this.fb.array([]),
      addresses: this.fb.array([]),
      websites: this.fb.array([]),
    });

    this.websites.push(this.fb.control(''));
    this.addresses.push(this.fb.control(''));
    this.phoneNumbers.push(this.fb.control(''));
    this.emails.push(this.fb.control(''));
  }

  // Add functions for adding/removing email, phone number, address, and website fields





  addContact(){
    this.formController = 'save';
    this.contactForm = this.fb.group({
      user_id:[this.user_id],
      firstName: [''],
      lastName: [''],
      tags: [''],
      gender: [''],
      company: [''],
      position: [''],
      facebook: [''],
      twitter: [''],
      linkedin: [''],
      
      emails: this.fb.array([]),
      phoneNumbers: this.fb.array([]),
      addresses: this.fb.array([]),
      websites: this.fb.array([]),
    });

    this.websites.push(this.fb.control(''));
    this.addresses.push(this.fb.control(''));
    this.phoneNumbers.push(this.fb.control(''));
    this.emails.push(this.fb.control(''));


    this.openAddContactModal()
  }

  editContact(contact: any) {
    // Populate the modal with contact data
    this.contactForm.patchValue({
      user_id: contact.user_id,
      firstName: contact.firstname,
      lastName: contact.lastname,
      tags: contact.tags,
      gender: contact.gender,
      company: contact.company,
      position: contact.position,
      facebook: contact.facebook,
      twitter: contact.twitter,
      linkedin: contact.linkedin,
      
    });

    // Pre-populate email, phone, address, and website fields in the modal
    this.populateFormArray('emails', contact.email);
    this.populateFormArray('phoneNumbers', contact.phone);
    this.populateFormArray('addresses', contact.address);
    this.populateFormArray('websites', contact.website);
    
    // Open the existing modal for editing
    this.updateContactId=contact.id
    this.formController='update'

    this.openAddContactModal();

  }

  // Function to populate a FormArray with values
  populateFormArray(formArrayName: string, values: any[]) {
    const formArray = this.contactForm.get(formArrayName) as FormArray;
    formArray.clear(); // Clear existing values
    values.forEach(value => {
      // Check if the value is an object and extract the property value
      if (typeof value === 'object' && value !== null) {
        // Iterate over the object properties and push their values to the form array
        Object.values(value).forEach(propertyValue => {
          formArray.push(this.fb.control(propertyValue));
        });
      } else {
        // If it's not an object, add it as is (assumes it's a valid string)
        formArray.push(this.fb.control(value));
      }
    });
  }

  // ...






  addEmail() {
    this.emails.push(this.fb.control(''));
  }

  removeEmail(index: number) {
    this.emails.removeAt(index);
  }

  addPhoneNumber() {
    this.phoneNumbers.push(this.fb.control(''));
  }

  removePhoneNumber(index: number) {
    this.phoneNumbers.removeAt(index);
  }

  addAddress() {
    this.addresses.push(this.fb.control(''));
  }

  removeAddress(index: number) {
    this.addresses.removeAt(index);
  }

  addWebsite() {
    this.websites.push(this.fb.control(''));
  }

  removeWebsite(index: number) {
    this.websites.removeAt(index);
  }


  

  openAddContactModal() {
    this.showModal = true;
  }

  closeAddContactModal() {
    this.showModal = false;
  }

  get emails() {
    return this.contactForm.get('emails') as FormArray;
  }

  get phoneNumbers() {
    return this.contactForm.get('phoneNumbers') as FormArray;
  }

  get addresses() {
    return this.contactForm.get('addresses') as FormArray;
  }

  get websites() {
    return this.contactForm.get('websites') as FormArray;
  }
}